import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import range from 'lodash/range';
import round from 'lodash/round';
import numericInput from '../../../../../lib/numericInput';
import BlankLink from '../../../../common/BlankLink';
import a from '../../../../../redux/actions';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';
import units from '../../../../../lib/units';

import InlineInput from '../InlineInput';
import InlineSelect from '../InlineSelect';

const waterTemperatureOptions = isMetric => range(120, 145, 5).map(value => ({
  value: round(isMetric ? units.farenheitToCelsius(value) : value),
  display: numericInput.format(isMetric ? units.farenheitToCelsius(value) : value),
}));

const fuelOptions = t => [
  { value: 0, display: t('natural gas') },
  { value: 1, display: t('electricity') },
];

const InstallTanklessWaterHeater = ({
  t,
  isMetric,
  widgetSource,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('My water heater is usually set to')}
        <InlineSelect
          options={waterTemperatureOptions(isMetric)}
          apiKey={'input_takeaction_tankless_water_heater_temp'}
        />
        {t('degrees {{tempUnits}} and runs on', {
          tempUnits: isMetric ? t('celsius') : t('farenheit'),
        })}
        <InlineSelect
          options={fuelOptions(t)}
          apiKey={'input_takeaction_tankless_water_heater_fueltype'}
        />.
      </p>
      <p>
        {t('I will replace my existing')}
        <InlineInput
          maxLength={2}
          apiKey={'input_takeaction_tankless_water_heater_replacements'}
        />
        {t('waterheater(s) with new natural gas heater(s) that cost')}
        <InlineInput
          currency
          maxLength={6}
          apiKey={'input_takeaction_tankless_water_heater_replacement_cost'}
        />
        {t('each.')}
      </p>
    </div>
    <div className="action-details__links">
      {widgetSource !== 'ontario' && <a
        href="http://www.coolcalifornia.org/funding-wizard#search/water+heater//false/none/false/1/12"
        target="_blank"
        rel="noopener noreferrer"
      >{t('Find rebates and incentives for this action')}</a>}
      {widgetSource === 'ontario' &&
        <p>
          {t('You can receive a $1600 incentive to upgrade your heating or cooling systems. Water heating is a large part of your household’s energy bill, and a high-efficiency or tank-less water heater can significantly reduce your energy consumption. To learn more about this program, check out')}
          &nbsp;
          <BlankLink href={`https://${t('greenon.ca/')}`} text="GreenOn.ca" />.
        </p>
      }
    </div>
  </div>
);

InstallTanklessWaterHeater.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  isMetric: PropTypes.bool.isRequired,
  widgetSource: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'isMetric',
  'widgetSource',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('tanklessWaterHeater'),
  connect(mapStateToProps, mapDispatchToProps)(InstallTanklessWaterHeater),
);
